import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import logo from "../images/geointelli-q.png"
import { useInView } from 'react-intersection-observer';
import { Container, Row, Col } from 'react-bootstrap';

function HeroSectionPage() {
    const heroControls = useAnimation();
    const [heroRef, heroInView] = useInView({
      threshold: 0.1,
      triggerOnce: true
    });
  
    useEffect(() => {
      if (heroInView) {
        heroControls.start('visible');
      }
    }, [heroControls, heroInView]);
  return (
    <div>
         {/* Hero Section */}
         <div className="hero-section">
        <motion.div
          ref={heroRef}
          initial="hidden"
          animate={heroControls}
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1, transition: { duration: 1 } }
          }}
          className="hero-overlay"
        >
          <Container>
            <Row className="justify-content-center">
              <Col md={10} className="text-center">
                <motion.h1
                  initial={{ y: 50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.8 }}
                  className="hero-title"
                >
                <img className='img-fluid mx-md-5 mx-3 p-md-5 p-5 w-50 h-50' src={logo} alt="geo_image"/>                </motion.h1>
                <motion.p
                  initial={{ y: 30, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                  className="hero-subtitle"
                >
                  Advanced Geosciences Analytics Platform
                </motion.p>
                <motion.div
                  initial={{ y: 30, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.6 }}
                >
                
                </motion.div>
              </Col>
            </Row>
          </Container>
        </motion.div>
      </div>
    </div>
  )
}

export default HeroSectionPage
